/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const personSkillSourceDataSchema = z.object({
	candidateId: z.string(),
	questionId: z.string(),
	optionId: z.string(),
})

export type PersonSkillSourceDataSchema = z.infer<typeof personSkillSourceDataSchema>
